import API from 'api';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';
import CurrentUser from './models/currentUser';

export const loadSuccess = (res) => ({
  type: C.LOAD_CURRENT_USER_SUCCESS,
  data: res,
});

export const load = () => (dispatch) => {
  dispatch({ type: C.LOAD_CURRENT_USER });
  return API.currentUser.load()
    .then(({ body: { data } }) => CurrentUser(data))
    .then((data) => {
      localStorage.setItem('currentUser', JSON.stringify(data));
      return dispatch(loadSuccess(data));
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_CURRENT_USER_ERROR, 'Error loading profile'));
    });
};
